import {z} from 'zod'

export const zodStringOptions = {
  required_error: 'Обязательное поле',
  invalid_type_error: 'Не строка',
}

export const zPhone = z.preprocess(
  // Преобразуем пустую строку в null до валидации
  value => (!value ? '' : value),
  // После преобразования выполняем валидацию
  z
    .string(zodStringOptions)
    .min(1, 'Обязательное поле')
    .regex(/(\+7 \(\d{3}\) \d{3}-\d{2}-\d{2})|(\+375 \(\d{2}\) \d{3}-\d{2}-\d{2})/, 'Некорректный формат'),
)

export const zEmail = z.preprocess(
  // Преобразуем пустую строку в null до валидации
  value => (value === '' ? null : value),
  // После преобразования выполняем валидацию
  z.string(zodStringOptions).max(320, 'Слишком большое значение').email({message: 'Некорректный формат'}).nullable(),
)

export const zFormRules = {
  phone: zPhone,
  email: zEmail,
}
